var map = {
	"./backGround.png": 3756,
	"./bicycleAnimation.gif": 8486,
	"./bot.png": 120,
	"./bottle11.png": 7643,
	"./bottle12.png": 1398,
	"./bottle13.png": 1643,
	"./bottle14.png": 3126,
	"./bottle15.png": 8883,
	"./bottle21.png": 3234,
	"./bottle22.png": 2559,
	"./bottle31.png": 6333,
	"./bottle32.png": 2563,
	"./bottle33.png": 8036,
	"./bottle41.png": 398,
	"./bottle42.png": 9071,
	"./bottle51.png": 2251,
	"./bottle52.png": 7625,
	"./bottle53.png": 8165,
	"./bottle61.png": 774,
	"./bottle62.png": 4251,
	"./bottle71.png": 2814,
	"./bottle72.png": 7900,
	"./bottle73.png": 276,
	"./cardImg1.png": 4794,
	"./cardImg2.png": 1343,
	"./cardImg3.png": 3724,
	"./do.jpg": 9759,
	"./download.png": 2177,
	"./drop.jpg": 315,
	"./emtyCart.gif": 4060,
	"./homeBg.png": 9851,
	"./homeCart.png": 881,
	"./hommebg2.png": 9348,
	"./leaf.jpg": 3529,
	"./magazineImg1.png": 7458,
	"./magazineImg2.png": 1547,
	"./magazineImg3.png": 2103,
	"./magazineImg4.png": 9100,
	"./magazineImg5.png": 1359,
	"./magazineImg6.png": 8062,
	"./magazineImg7.png": 2837,
	"./shopImg1.png": 4675,
	"./shopImg2.png": 8058,
	"./shopImg3.png": 2076,
	"./us.svg": 9133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;